import More from '../components/More';
import { connect } from 'react-redux';

const mapStateToProps = state => {
	return {
		moreType: state.data.more.moreType,
		more: state.data.more.more,
		permalink: state.data.more.permalink,
		commentsMore: state.data.more.commentsMore,
	}
}

export default connect( mapStateToProps )( More );
